<template>
  <button
    :type="type"
    class="button-base"
    :class="{'w-100': full}"
    @click="$emit('click'); $emit('clicked')"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'button'
      },

      full: {
        type: Boolean,
        default: false,
      },

      active: {
        type: Boolean,
        default: false,
      },

      disabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .button-base {
    display: inline-block;
    border-radius: 5px;
    background: $highlightPrimaryColor;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding: 12px 30px;
    transition: .5s all;

    &:hover, &:focus {
      background: lighten($highlightPrimaryColor, 10%);
    }
  }
</style>